import { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

function MyChart_timeseries({ MLResults = [], secondResult = [] }) {
  const [mlDatasets, setMLDatasets] = useState([]);
  const [maxY1, setMaxY1] = useState(0.01);
  const [maxY2, setMaxY2] = useState(0.01);
  let my1 = 0.01
  let my2 = 0.01

  const processMLResults = async () => {
    try {
      const results = await Promise.all(MLResults)
      const results2 = await Promise.all(secondResult)

      results.forEach((result) => {
        result[0].forEach((item) => {
          if (item[1] > my1) {
            my1 = item[1]
          }
        });

        result[1].forEach((item) => {
          if (item[1] > my2) {
            my2 = item[1]
          }
        });
      });

      const processedResults = results.map((result, i) =>
        result[0].map((item) => ({ x: item[0], y: item[1] }))
      );

      const processedInput = results.map((result, i) =>
        result[1].map((item) => ({ x: item[0], y: item[1] }))
      );

      results2.forEach((result) => {
        result[1].forEach((item) => {
          if (item[1] > my1) {
            my1 = item[1]
          }
        });

        /*result[1].forEach((item) => {
          if (item[1] > my2) {
            my2 = item[1]
          }
        });*/
      });
      
      setMaxY1(my1)
      setMaxY2(my2)

      const processedResults2 = results2.map((result, i) =>
        result[1].map((item) => ({ x: item[0], y: item[1] }))
      );

      setMLDatasets([
        ...processedResults.map((v, i) => ({
          label: 'ML' + i.toString().padStart(2, '0'),
          yAxisID: 'y',
          data: v,
          backgroundColor: 'rgba(75, 192, 192, 0.7)',
          borderColor: 'rgba(75, 192, 192, 0.7)',
          pointRadius: 0,
          borderWidth: 2,
          pointHitRadius: 20,
        })),
        {
          label: 'input',
          yAxisID: 'y2',
          data: processedInput[0],
          backgroundColor: 'rgba(75, 192, 192, 0.7)',
          borderColor: 'rgba(75, 192, 192, 0.7)',
          pointRadius: 0,
          borderWidth: 2,
          pointHitRadius: 20,
        },
        {
          label: 'Source Models',
          yAxisID: 'y',
          data: processedResults2[0],//result2,
          backgroundColor: 'rgba(255, 99, 132, 1)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 3,
          pointRadius: 0,
          pointHitRadius: 20,
        }
      ]);
    } catch (error) {
      console.error('Error processing MLResults:', error);
    }
  };

  useEffect(() => {
    processMLResults();
  }, [MLResults, secondResult]);

  /*const result2 = secondResult.map((v) => ({ x: v[0][0], y: v[1] }));
  result2.sort((a, b) => a.x - b.x);*/

  const data = {
    datasets: [
      ...mlDatasets,
      /*{
        label: 'Source Models',
        yAxisID: 'y',
        data: processedResults2,//result2,
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 3,
        pointRadius: 0,
        pointHitRadius: 20,
        fill: false,
      },*/
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: 'time',
        distribution: 'linear',
        position: 'bottom',
      },
      y: {
        min: 0,
        max: maxY1 * 2.2,
        type: 'linear',
        position: 'left',
      },
      y2: {
        min: 0,
        max: maxY2 * 2.2,
        type: 'linear',
        position: 'right',
        reverse: true,
      },
    },
  };

  useEffect(() => {
    // Update chart options when maxY1 or maxY2 changes
    options.scales.y.max = maxY1 * 2.2;
    options.scales.y2.max = maxY2 * 2.2;
  }, [maxY1, maxY2]);

  return <Line data={data} options={options} />;
}

export default MyChart_timeseries;
